export default "__VITE_ASSET__B9SQL5lZ__"